import React from 'react'
import styled from 'styled-components'

const Block = styled.div`
  border-radius: 25px;
`

interface PrivacyProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Privacystatement
}

const Privacy: React.FC<PrivacyProps> = () => (
  <section className="bg-background">
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 text-text">
          <Block className="bg-backgroundAlt p-lg-5 p-4">
            <div data-ubo-consent-declaration />
          </Block>
        </div>
      </div>
    </div>
  </section>
)

export default Privacy
